<template>
  <div class="info-board job-detail-stats f-r">
    <div class="stats-info-card blue-business-bg" v-if="showActualPalletCount">
      <div class="info-card-left">
        <span class="title">{{ actualPalletCount }} Pallets</span>
        <span class="sub-title">Actual Pallets</span>
      </div>
    </div>
    <div class="stats-info-card blue-business-bg" v-if="showActualPalletCount">
      <div class="info-card-left">
        <span class="title"
          >{{ palletIds.length - actualPalletCount }} Pallets</span
        >
        <span class="sub-title">Invalid Upcomming</span>
      </div>
    </div>
    <div
      class="stats-info-card blue-business-bg"
      v-if="jobType === UnloadingJob && jobStatus === JobProcessing"
    >
      <div class="info-card-left">
        <span class="title">{{ totalPalletCount }} Pallets</span>
        <span class="sub-title">In Total</span>
      </div>
    </div>
    <div class="stats-info-card blue-business-bg" v-if="showPalletInTotal">
      <div class="info-card-left">
        <span class="title">{{ palletIds.length }} Pallets</span>
        <span class="sub-title">In Total</span>
      </div>
    </div>
    <div
      class="stats-info-card blue-business-bg"
      v-if="showCompletedPalletCount"
    >
      <div class="info-card-left">
        <span class="title">{{ 0 }} Pallets</span>
        <span class="sub-title">Completed</span>
      </div>
    </div>
    <div class="stats-info-card blue-business-bg" v-if="showTotalQuantity">
      <div class="info-card-left">
        <span class="title">{{ totalQuantity }} Qty</span>
        <span class="sub-title">In Total</span>
      </div>
    </div>
    <div class="stats-info-card blue-business-bg" v-if="showTotalCBM">
      <div class="info-card-left">
        <span class="title">{{ totalCMB }} CBM</span>
        <span class="sub-title">In Total</span>
      </div>
    </div>
  </div>
</template>
<script>
// models
import {
  PalletDelivered,
  PalletOffStack,
  PalletOnStack,
  PalletOnStage,
  PalletShipping,
  PalletUpcoming
} from '@/core/models/pallet'
import {
  UnloadingJob,
  InboundJob,
  JobCompleted,
  JobProcessing,
  OutboundJob,
  JobUnassigned,
  JobAssigned,
  JobDeleted
} from '@/core/models/constant'
// mixin
import { pageJumps } from '@/core/mixin/pages'
import { queryPallets } from '@/api/pallet'
export default {
  name: 'OrderStats',
  mixins: [pageJumps],
  props: {
    jobId: {
      type: String,
      required: true
    },
    job: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      UnloadingJob,
      JobCompleted,
      InboundJob,
      JobProcessing
    }
  },
  watch: {},
  computed: {
    showTotalCBM() {
      return this.jobType === UnloadingJob
    },
    showTotalQuantity() {
      return this.jobType === UnloadingJob
    },
    showActualPalletCount() {
      const flag1 =
        this.jobType === UnloadingJob && this.jobStatus === JobCompleted
      const flag2 =
        this.jobType === InboundJob && (this.job?.unloadingJobId ?? undefined)
      return flag1 || flag2
    },
    showCompletedPalletCount() {
      const flag1 = this.jobType === InboundJob
      const flag2 = this.jobType === OutboundJob
      return flag1 || flag2
    },
    showPalletInTotal() {
      const flag1 =
        this.jobType === InboundJob && !(this.job?.unloadingJobId ?? undefined)
      const flag2 = this.jobType === OutboundJob
      const flag3 =
        this.jobType === UnloadingJob &&
        [JobUnassigned, JobAssigned, JobDeleted].includes(this.jobStatus)
      return flag1 || flag2 || flag3
    },
    jobType() {
      return this.job?.type
    },
    jobStatus() {
      return this.job?.status
    },
    totalQuantity() {
      return (
        this.job?.goodsGroups.reduce((one, two) => one + two.quantity, 0) ?? 0
      )
    },
    totalCMB() {
      return (
        this.job?.goodsGroups.reduce((one, two) => one + two.cmb, 0) ?? 0
      ).toFixed(2)
    },
    palletIds() {
      const procesing = this.job?.processingPalletIds ?? []
      const done = this.job?.donePalletIds ?? []
      return [...procesing, ...done]
    },
    actualPalletCount() {
      return this.job?.actualPalletCount ?? 0
    },
    completedPalletCount() {
      return this.job?.donePalletIds?.length ?? 0
    },
    totalPalletCount() {
      if (this.job.type === InboundJob && this.job.unloadingJobId) {
        return this.job?.actualPalletCount ?? 0
      } else {
        return (
          (this.job?.donePalletIds?.length ?? 0) +
          (this.job?.processingPalletIds?.length ?? 0)
        )
      }
    }
  },
  methods: {
    getCardStyle(status) {
      switch (status) {
        case PalletUpcoming:
          return 'deep-yellow-bg'
        case PalletOnStack:
          return 'blue-business-bg'
        case PalletOffStack:
          return 'hash-brown-bg'
        case PalletOnStage:
          return 'blue-business-bg'
        case PalletDelivered:
          return 'deep-green-bg'
        case PalletShipping:
          return 'deep-green-bg'
      }
    },
    countAllPallets() {
      Object.keys(this.palletCounts).forEach(status => {
        this.countPallets(status)
      })
    },
    countPallets(status) {
      queryPallets({
        statusList: [status],
        size: 1000,
        current: 1,
        orderIds: [this.orderId]
      }).then(res => {
        this.palletCounts[status] = res.total
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  min-width: 900px;
  gap: 10px;

  @extend .f-r;

  .stats-info-card {
    pointer-events: none;
    width: 200px;
    padding: 22px 20px;

    .info-card-left {
      .title {
        font-size: 24px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald bold', sans-serif;
      }
    }
  }
}
</style>
